import { Flex, Input } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";
import CustomReactSelect from "../../../general/form/CustomReactSelect";
import { useAppContext } from "../../../../contexts/AppContext";

const OnboardingStep13 = ({ formData, handleChange }) => {
  const { currencies } = useAppContext();

  return (
    
<>   
    

      <Flex direction="column" gap={8}>
        <h6>Basic information</h6>
        <Flex direction="column">
          <Fieldset
            label="Reference Currency"
            description="Select the primary currency used for financial reporting and transactions."
            flex={1}
            input={
              <CustomReactSelect
                name="referenceCurrency"
                options={currencies}
                placeholder="Choose reference currency"
                value={currencies.find(
                  (option) => option.value === formData.referenceCurrency
                )}
                onChange={(selectedOption) =>
                  handleChange({
                    target: {
                      name: "handleCurrencyChange",
                      value: selectedOption ? selectedOption.value : "",
                    },
                  })
                }                
                isSearchable
              />
            }
          />

          <Fieldset
            label="Incorporation Date"
            description="Select the official date when the fund was incorporated."
            input={
              <Input
                name="incorporationDate"
                type="date"
                value={formData.incorporationDate}
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Financial Year End"
            description="Choose the end date of the financial year for the fund."
            flex={1}
            input={
              <CustomReactSelect
                name="financialYearEnd"
                placeholder="Choose financial year end"
                options={[
                  { value: "31/12", label: "31/12" },
                  { value: "31/03", label: "31/03" },
                  { value: "30/06", label: "30/06" },
                  { value: "30/09", label: "30/09" },
                ]}
                value={{
                  value: formData.financialYearEnd,
                  label: formData.financialYearEnd,
                }}
                onChange={(selectedOption) =>
                  handleChange({
                    target: {
                      name: "financialYearEnd",
                      value: selectedOption ? selectedOption.value : "",
                    },
                  })
                }
                
              />
            }
          />
        </Flex>
      </Flex>
</>
  );
};

export default OnboardingStep13;
